<template>
  <div class="group-buy-block-layout">
    <div class="title-block">
      <h4 class="block-title">{{ title }}</h4>
      <slot name="qrCode"></slot>
    </div>
    <div class="block-content">
      <slot name="list"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GroupBuyDetailBlock',
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .group-buy-block-layout {
    background-color: @color-white;
    padding: 0 @size-medium;
  }

  .title-block {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border-bottom: @border-base;
  }

  .block-title {
    margin: 0;
    line-height: 1;
    padding: @size-base @size-extra-small;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
  }
</style>
